import React, { createContext, useState } from 'react';

type NavVisibilityContextValue = {
    showNav: boolean;
    setShowNav: (value: boolean) => void;
};

export const NavVisibilityContext = createContext<
    NavVisibilityContextValue | undefined
>(undefined);

export const NavVisibilityProvider: React.FC<{ children: React.ReactNode }> = ({
    children
}) => {
    const [showNav, setShowNav] = useState(true);

    return (
        <NavVisibilityContext.Provider value={{ showNav, setShowNav }}>
            {children}
        </NavVisibilityContext.Provider>
    );
};
